import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

function SignoutCallbackComponent({ userManager }) {
  const navigate = useNavigate();

  const onRedirectSuccess = (/* user */) => {
    const redirectData = sessionStorage.getItem('ohif-redirect-to');
    let { pathname, search = '' } = redirectData
      ? JSON.parse(redirectData)
      : { pathname: '/submissions' };

    // Ensure we don't redirect to dashboard, default to submissions instead
    if (pathname === '/dashboard') {
      pathname = '/submissions';
    }

    navigate(`${pathname}?${search}`);
  };

  const onRedirectError = error => {
    throw new Error(error);
  };

  userManager
    .signoutRedirectCallback()
    .then(user => onRedirectSuccess(user))
    .catch(error => onRedirectError(error));

  return null;
}

SignoutCallbackComponent.propTypes = {
  userManager: PropTypes.object.isRequired,
};

export default SignoutCallbackComponent;
